<template>

    <div class="bg">
        <img src="../assets/images/bg.jpg" alt="">
        <div class="login-center">
            <div class="login-l">
                <img src="../assets/images/login-img.png" alt="">
            </div>

            <div class="login-r">
                <h3>智享订房系统</h3>
                <p>Welcome欢迎登录</p>
                <el-form ref="loginForm" :model="loginForm" label-width="70px" size="small" :rules="rulesForm">
                    <el-form-item label="账号" prop="username">
                        <el-input type="text" v-model="loginForm.username" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <div class="login_code">
                            <el-input @keyup.enter.native="login" type="text" v-model="loginForm.code" placeholder="请输入验证码"></el-input>
                            <img :src="codeUrl" alt="" @click="refreshCode"/>
                        </div>
                    </el-form-item>
                    
                </el-form>

                <button @click="login">登录</button>
            </div>
           
        </div>
    </div>

</template>

<script>
    import {get, post} from "../utils/request";
    import VueQr from 'vue-qr';

    export default {
        name: "login",
        components: {
            VueQr,
        },

        data() {
            return {
                loginForm: {
                    username: '',
                    password: '',
                    randomStr: "",
                    code: ""
                },
                rulesForm: {
                    username: [{required: true, message: '请输入用户名', trigger: "change"}],
                    password: [{required: true, message: '请输入密码', trigger: "change"}],
                    code: [{ required: true, message: '请输入验证码', trigger: "change" }],
                },
                codeUrl: "",
                randomStr: "",

            }
        },
        methods: {
          
            //登录
            login() {
                this.$refs.loginForm.validate((valid) => {
                    if(valid) {
                        post('/auth/login', this.loginForm)
                        .then(res => {
                            console.log('登录信息:', res);
                            //判断返回的数据是否存在token和用户id
                            if (res.data.data.token && res.data.data.userInfo.id) {
                                // 将token及用户id存放到Vuex中
                                this.$store.commit('SAVE_TOKEN', res.data.data.token)
                                this.$store.commit('SAVE_USER_ID', res.data.data.userInfo.id)
                                this.$store.commit('SET_MENU_LIST', res.data.data.menuList)
                                //将导航菜单存到localStorage
                                // localStorage.setItem('menuList', JSON.stringify(res.data.data.menuList))
                                //路由跳转
                                this.$router.push({
                                    path: '/index'
                                })

                            } else {
                                console.log('token或用户id不存在，登录失败');
                                this.refreshCode();

                            }
                        })
                        .catch(err => {
                            console.log(err)
                            this.refreshCode();

                        })
                    }
                })
                
                
            },
            refreshCode() {
                this.loginForm.randomStr = new Date().getTime();
                this.codeUrl = `${window.location.origin}/room/df-front/code/getLoginCode?randomStr=${this.loginForm.randomStr}`;
                this.loginForm.code = "";
            }

        },
        mounted() {
            //页面挂载完毕清除token和用户id
            this.refreshCode();
            localStorage.removeItem('Token')
            localStorage.removeItem('userId')
            localStorage.removeItem('menuId')
        }
    }
</script>

<style>
    * {
        padding: 0;
        margin: 0;
    }

    .bg {
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .bg img {
        width: 100%;
        height: 100%;
        opacity: 0.6;
        position: absolute;
    }

    .login-center {
        width: 700px;
        height: 300px;
        background-color: #fff;
        box-shadow: 0px 0px 40px -10px #000;
        border-radius: 20px;
        padding: 60px 50px;
        display: flex;
        z-index: 9;
        justify-content: space-between;
    }

    .login-l img {
        width: 300px;
        height: 300px;
        opacity: 1;
    }

    .login-l, .login-r {
        width: 100%;
    }

    .login-r h3 {
        font-size: 25px;
        font-weight: normal;
        margin-top: 10px;
    }

    .login-r p {
        margin-top: 10px;
        margin-bottom: 20px;
        color: #666666;
    }

    .login_code {
        display: flex;
        align-items: center;
        position: relative;
    }

    .login_code img {
        width: 100px;
        height: 40px;
        position: absolute;
        top: 5px;
        right: 0;
    }
    
   

    .login-r button {
        width: 300px;
        height: 35px;
        background-color: #4f93fe;
        color: #fff;
        border-radius: 50px;
        border: none;
        margin-top: 50px;
        cursor: pointer;
    }

    .login-r .el-form-item--small {
        margin: 0;
        border-bottom: 1px solid #EEEEEE;
        padding: 5px 0;
    }

    .login-r .el-input__inner {
        border: none;
        height: 40px;
        line-height: 40px;
    }

    .login-r .el-form-item__label {
        line-height: 40px;
    }

    .el-form-item__error {
        z-index: 11111;
    }
</style>